export default "__VITE_ASSET__BPcqOHzr__"